export default class Autocomplete {
    suggestionContainer;

    createContainer() {
        const autocompleteSuggestionsContainer = document.createElement('div');
        autocompleteSuggestionsContainer.hidden = true;
        autocompleteSuggestionsContainer.classList.add(
            'rounded-lg',
            'border',
            'border-gray-300',
            'divide-y',
            'bg-white',
            'cursor-pointer',
            'overflow-y-auto',
            'max-h-56',
            'shadow-lg',
            'md:max-h-96',
            'dark:bg-gray-700',
        );
        autocompleteSuggestionsContainer.dataset.bound = 'false';
        this.suggestionContainer = autocompleteSuggestionsContainer;

        return this.suggestionContainer;
    }

    createElement(text) {
        const element = document.createElement('div');
        element.classList.add(
            'first:rounded-t-lg',
            'last:rounded-b-lg',
            'transition-colors',
            'duration-500',
            'px-3',
            'text-gray-900',
            'border-gray-200',
            'py-2',
            'hover:bg-gray-100',
            'dark:text-gray-200',
            'dark:hover:bg-gray-600',
            'dark:bg-gray-700',
            'dark:border-gray-600',
        );

        if (text) {
            element.innerText = text;
        }

        return element;
    }
}
